<!--
 * @Description: 
 * @Author: HG
 * @Date: 2019-08-21 13:38:08
 * @LastEditors: HG
 * @LastEditTime: 2020-02-19 16:08:48
 -->
<template>
  <div class="container">
    <head-nav-bar :title="title" :fixed="true" />
    <div class="doctor-list mt-header-nav">
      <form action="/">
        <van-search
          v-model="keyword"
          placeholder="请输入搜索关键词"
          show-action
          @search="onSearch"
        >
          <div slot="action" @click="showScreen">
            <span class="font-color-active"
              ><van-icon name="filter-o" />筛选</span
            >
          </div>
        </van-search>
      </form>
      <DataList ref="doctorList" api="Doctor_List" :params="params">
        <template v-slot:item="item">
          <div class="doctor-item" @click="selectedDoctor(item.obj)">
            <doctor-card :data="item.obj" />
          </div>
        </template>
      </DataList>

      <van-popup
        v-model="visible.screen"
        class="popup-absolute"
        position="top"
        :style="{ height: '12rem' }"
        :overlay-style="{ top: '1.22667rem' }"
        :get-container="getContainer"
        @close="onClosePopup"
      >
        <doctor-screen
          @close="visible.screen = false"
          ref="doctorScreen"
          :disabledDate="type === 'today' ? true : false"
          @submit="onScreen"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import { Search, Icon, Popup } from "vant";
import DataList from "@/components/DataList";
import DoctorScreen from "./DoctorScreen";
import DoctorCard from "@/components/DoctorCard";
import { formatDate, countDate } from "@/utils/common";
import { mapState, mapActions } from "vuex";
export default {
  name: "DoctorList",
  components: {
    DataList,
    DoctorScreen,
    DoctorCard,
    [Search.name]: Search,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
  },
  data() {
    return {
      title: "选择医生",
      keyword: "",
      visible: {
        screen: false,
      },
      list: [],
      loading: false,
      finished: false,
      screen: {},
      type: "",
      params: {
        DepartmentId: "",
        Name: "",
      },
    };
  },
  computed: {
    ...mapState({
      order: (state) => state.order,
    }),
  },
  created() {
    this.type = this.$route.query.type;
    this.params.DepartmentId = this.order.DepartmentId
      ? this.order.DepartmentId
      : 0;
    if (!this.type) {
      this.params.StartWorkDate = countDate(formatDate(), 1);
      this.params.EndWorkDate = countDate(this.params.StartWorkDate, 13);
    } else {
      this.params.StartWorkDate = formatDate();
      this.params.EndWorkDate = this.params.StartWorkDate;
    }

    // this.$refs.doctorList.onLoad(params);
  },

  methods: {
    ...mapActions(["setDoctor"]),

    onSearch(keyword) {
      const params = {
        DepartmentId: this.order.DepartmentId,
        Name: keyword,
      };
      if (!this.type) {
        params.StartWorkDate = countDate(formatDate(), 1);
        params.EndWorkDate = countDate(params.StartWorkDate, 13);
      } else {
        params.StartWorkDate = formatDate();
        params.EndWorkDate = formatDate();
      }
      this.params = params;
    },

    showScreen() {
      this.visible.screen = true;
    },

    getContainer() {
      return document.querySelector(".doctor-list");
    },

    onScreen(data) {
      //执行医生列表查询
      console.log(data);
      // this.onLoad(data);
      this.screen = data;
      this.visible.screen = false;
      this.keyboard = "";
      const params = {
        ...this.params,
        DepartmentId: this.order.DepartmentId,
      };
      if (data.date && data.date.length) {
        params.StartWorkDate = data.date[0];
        params.EndWorkDate = data.date[1];
      }
      if (Number(data.value) !== 0) {
        params.SourceType = Number(data.value);
      }
      this.params = params;
    },

    onClosePopup() {
      this.$refs.doctorScreen.closePopup();
    },

    selectedDoctor(info) {
      this.setDoctor(info);
      if (
        this.screen &&
        this.screen.date &&
        this.screen.date.length &&
        this.screen.date[0] === this.screen.date[1]
      ) {
        //已选择指定一个日期
        this.$router.push({
          name: "servePreOrderDoctorInfo",
          query: {
            Id: info.id,
            date: this.screen.date[0],
            QueueId: info.queueId,
          },
        });
      } else {
        let query = {
          Id: info.id,
          QueueId: info.queueId,
        };
        if (this.type === "today") {
          query.date = formatDate();
        }
        //跳转医生详情，可选日期
        this.$router.push({ name: "servePreOrderDoctorInfo", query });
      }
    },
  },
};
</script>

<style lang="less">
.doctor-list {
  position: relative;
  min-height: 80vh;
  .van-card__content {
    display: inline;
  }
}
</style>
